export default {
  presentation: {
    height: '0',
    paddingBottom: '56%',
    borderRadius: '0',
    background: '#ececec'
  }
}
